import { inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { CanActivateChildFn, Router } from '@angular/router'
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular'
import Keycloak from 'keycloak-js'
import { filter, firstValueFrom } from 'rxjs'
/**
 * Guard to protect integration platforms routes, only accessible for authenticated users with integration admin role.
 * @returns {Promise<boolean>} A boolean indicating whether the user is allowed to access the route.
 */

export const authGuard: CanActivateChildFn = async () => {
  const router = inject(Router)
  const keycloak = inject(Keycloak)
  const keycloakEventSignal = inject(KEYCLOAK_EVENT_SIGNAL)

  if (keycloakEventSignal()?.type !== KeycloakEventType.Ready) {
    await firstValueFrom(
      toObservable(keycloakEventSignal).pipe(
        filter((event) => event?.type === KeycloakEventType.Ready),
      ),
    )
  }

  if (keycloak.authenticated && keycloak.hasRealmRole('integration_admin')) {
    return true
  }

  return router.parseUrl('/')
}
